export enum EnvEnum
{
    dev = 'dev',
    local = 'local',
    hml = 'hml',
    prod = 'prod',
    demo = 'demo',
}